import { H4 } from 'foundations-components/transitional/components/H4';
import FormattedMessage from 'I18n/components/FormattedMessage';
//@ts-expect-error Could not find declaration file for module
import playlistTableUrl from 'bender-url!../../../../images/playlist-table.svg';
import { Image } from 'foundations-components/transitional/components/Image';
import { AssignPlaylistButton } from './AssignPlaylistButton';
import BlankPageMediaWrapper from '../../../components/BlankPageMediaWrapper';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlaylistAssignmentsBlankPageContentForPlaylist = ({
  playlistId,
  portalId
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.blank.header"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.blank.body"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(AssignPlaylistButton, {
        block: true,
        playlistId: playlistId,
        portalId: portalId,
        use: "secondary"
      })
    })]
  });
};
const ItemRightComponent = props => {
  return /*#__PURE__*/_jsx(Image, Object.assign({
    src: playlistTableUrl
  }, props));
};
const PlaylistAssignmentsBlankPage = ({
  playlistId,
  portalId
}) => {
  return /*#__PURE__*/_jsx(BlankPageMediaWrapper, {
    itemRightComponent: ItemRightComponent,
    children: /*#__PURE__*/_jsx(PlaylistAssignmentsBlankPageContentForPlaylist, {
      playlistId: playlistId,
      portalId: portalId
    })
  });
};
export default PlaylistAssignmentsBlankPage;